import React, { memo } from 'react';

import Form from 'react-bootstrap/Form';

import i18n from '../messages.json';
import BrazeChannelBody from './BrazeChannelBody';

/**
 * Input phase of the Send Test dialog — the form the user fills in before
 * clicking Send. Braze is the only channel (WWW-15561 removed Firebase), so the
 * recipient form is rendered directly with no channel toggle. State is parent-owned.
 *
 * Props (passed through verbatim to BrazeChannelBody):
 *   hasCampaigns
 *   brazeRecipients, onBrazeRecipientsChange
 */
const SendTestInputView = ({
  hasCampaigns,
  brazeRecipients,
  onBrazeRecipientsChange,
}) => (
  <Form>
    <p className='send-test__intro'>{i18n.ink.notification.sendTest.intro}</p>
    <BrazeChannelBody
      hasCampaigns={hasCampaigns}
      recipients={brazeRecipients}
      onRecipientsChange={onBrazeRecipientsChange}
    />
  </Form>
);

export default memo(SendTestInputView);
